@if (showLauncher()) {
    <!-- Stacked above the "Ask a Question" launcher (bottom-6) so both can be mounted at once. -->
    <div class="feedback-launcher fixed bottom-20 right-4 z-50 shadow-lg" [class.feedback-launcher--open]="showDialog()">
        <app-button
            [label]="'FEEDBACK.WIDGET.TRIGGER' | translate"
            endIcon="/icons/message.svg"
            [ariaLabel]="'FEEDBACK.WIDGET.TRIGGER' | translate"
            (onClick)="open()" />
    </div>

    <app-feedback-dialog [visible]="showDialog()" [contextLabel]="contextLabel()" (visibleChange)="showDialog.set($event)" />
}
